import { render, staticRenderFns } from "./SurveillanceYSY.vue?vue&type=template&id=056e37ba&scoped=true&"
import script from "./SurveillanceYSY.vue?vue&type=script&lang=js&"
export * from "./SurveillanceYSY.vue?vue&type=script&lang=js&"
import style0 from "./SurveillanceYSY.vue?vue&type=style&index=0&id=056e37ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056e37ba",
  null
  
)

export default component.exports